import { render, staticRenderFns } from "./pending-payments.vue?vue&type=template&id=79a7d284&scoped=true"
import script from "./pending-payments.vue?vue&type=script&lang=js"
export * from "./pending-payments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a7d284",
  null
  
)

export default component.exports